// istanbul ignore file

import styled from 'styled-components';

export const BannerWrapper = styled.div`
    width: auto;
`;

export const StyledBodyContainer = styled.div`
    background-color: ${({ theme }) => theme.tokens.BaseColorWhite};
    display: flex;
    flex-direction: column;
    height: 100%;
    padding-top: 0;
`;
